import React from "react";
import { Route } from "react-router-dom";
import Home from "./pages/Home";
import Projects from "./pages/Projects";
import ProjectPage from "./pages/ProjectPage";
import Models from "./pages/Models";
import ModelPage from "./pages/ModelPage";
import MyModels from "./pages/MyModels";
import Results from "./pages/Results";
import M2dSearch from "./pages/Search";
import Admin from "./pages/Admin";
import Inbox from "./pages/Inbox";
import History from "./pages/History";
import LandingPage from "./pages/LandingPage";
import M2dProfile from "./pages/Profile";
import ProtectedRoute from "../../common/ProtectedRoute";

const m2dRoutes = <>
  <Route path="/modelmeetsdata" element={<LandingPage />}></Route>,
  <Route path="/m2d" element={
    <ProtectedRoute>
      <Home />
    </ProtectedRoute>
  }>
    <Route path="/m2d" element={<Projects />} />
    <Route path="/m2d/projects" element={<Projects />} />
    <Route path="/m2d/projects/:pid" element={<ProjectPage />} />
    <Route path="/m2d/models" element={<Models />} />
    <Route path="/m2d/models/:mid" element={<ModelPage />} />
    <Route path="/m2d/mymodels" element={<MyModels />} />
    <Route path="/m2d/inbox" element={<Inbox />} />
    <Route path="/m2d/history" element={<History />} />
    <Route path="/m2d/history/results" element={<Results />} />
    <Route path="/m2d/profile" element={<M2dProfile />} />
    <Route path="/m2d/search" element={<M2dSearch />} />
    <Route path="/m2d/hanyuhu" element={<Admin />} />
  </Route>
</>;

export default m2dRoutes;